var styles = {
  "Item": "Online-Store-UI-Item_cqdv4",
  "offsetLeft": "Online-Store-UI-Item--offsetLeft_14s71",
  "offsetRight": "Online-Store-UI-Item--offsetRight_ir874",
  "grow": "Online-Store-UI-Item--grow_cpr0f"
};

export { styles as default };
